import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=e4bc4854&"
import script from "./Testing.vue?vue&type=script&lang=ts&"
export * from "./Testing.vue?vue&type=script&lang=ts&"
import style0 from "./Testing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
